export enum QuestionTypes {
  FREE_FORM = 'free_form',
  MULTIPLE_CHOICE = 'multiple_choice',
  DROPDOWN = 'dropdown',
  LONG_TEXT = 'long_text',
}

export type FormQuestionTypes =
  | QuestionTypes.FREE_FORM
  | QuestionTypes.MULTIPLE_CHOICE
  | QuestionTypes.DROPDOWN
  | QuestionTypes.LONG_TEXT;

export enum FormStatus {
  DRAFT = 'draft',
  LIVE = 'live',
  ARCHIVED = 'archived',
}
export type FormStatusTypes = FormStatus.DRAFT | FormStatus.LIVE | FormStatus.ARCHIVED;

export interface CustomField {
  id: string;
  kind: string;
}

export interface FormQuestionOption {
  id: string;
  value: string;
}

export interface PublicationFormQuestion {
  id: string;
  order: number;
  prompt: string;
  question_type: FormQuestionTypes;
  required: boolean;
  multi_select: boolean;
  max_character_limit: number;
  min_character_limit: number;
  show_max_characters: boolean;
  custom_field: CustomField;
  form_question_options: FormQuestionOption[];
}

export interface PublicationForm {
  id: string;
  title: string;
  description: string;
  cta_text: string;
  thank_you_message: string;
  status: FormStatusTypes;
  form_questions: PublicationFormQuestion[];
}
